// Contenu de la plaquette — Onglet "Qui suis-je ?"
// Sections A (présentation), B, C, D (page "Mais c'est quoi la
// psychothérapie ?")

export const presentation = {
  name: "Tamila Hachemi",
  title: "Psychologue / Psychothérapeute",
  paragraphs: [
    "Psychosociologue de formation, consultante internationale, thérapeute et formatrice depuis plus de 10 ans.",
    "Je travaille sur les questions d'identités intersectionnelles, croisant culture, genre, sexualité, neuroatypie et spiritualité.",
    "Par ailleurs, j'accompagne les dynamiques de changement communautaire et de vivre-ensemble interculturel.",
  ],
};

// Section B — page 3
export const introSection = {
  heading: "Avant toute chose !",
  text:
    "Oubliez tout ce que vous savez ou pensez savoir sur la thérapie et repartons de la base !",
  image: {
    src: "/illustration-tete-motifs.jpg",
    alt: "Illustration d'un profil humain rempli de motifs géométriques",
  },
};

// Section C — page 4
export const definitionsSection = {
  heading:
    "Psychologie, psychothérapie, thérapie, psychanalyse !? Je me perds, qu'y a-t-il d'important à retenir ?",
  paragraphs: [
    "La psychologie est une science, à la fois humaine et biologique, qui étudie les comportements et les processus mentaux. Elle comprend plusieurs disciplines (clinique, sociale, cognitive, neuropsychologique…).",
    "La psychothérapie est une spécialité de la psychologie visant à traiter les troubles psychiques, émotionnels ou comportementaux par un espace de dialogue structuré et de confiance avec un professionnel qualifié. À distinguer de la thérapie, qui désigne tout soin apporté à une personne, la psychothérapie ne peut être exercée en France que par des praticiens habilités (psychologues, psychiatres, psychothérapeutes, psychanalystes…).",
    "En France, l'histoire de la psychothérapie reste fortement marquée par la psychanalyse (Freud, Lacan et leurs héritiers), qui postule que les troubles trouvent leur origine dans l'inconscient et les expériences infantiles, en mettant l'accent sur le passé.",
    "Dans un monde en constante évolution, j'ai choisi de me positionner comme psychologue dans une approche intersectionnelle.",
  ],
};

// Section D — page 5
export const intersectionalitySection = {
  heading: "Qu'est-ce que l'approche intersectionnelle ?",
  image: {
    src: "/illustration-visages-intersectionnels.jpg",
    alt: "Illustration de plusieurs visages entrecroisés",
  },
  paragraphs: [
    "L'approche intersectionnelle est une méthode thérapeutique qui reconnaît que l'identité d'une personne se construit à travers plusieurs dimensions sociales (genre, origine, classe, orientation sexuelle, spiritualité, handicap, etc.), dont l'entrecroisement façonne des expériences singulières de vulnérabilité, de privilège ou d'oppression.",
    "Plutôt que de réduire l'individu à une seule appartenance (femme, migrant, musulmane, personne queer, etc.), elle prend en compte la combinaison de ces identités et leur impact sur la santé mentale, les traumatismes et les ressources personnelles. Elle propose ainsi un accompagnement plus juste, contextualisé et inclusif, en évitant les généralisations et en s'adaptant à la réalité complexe de chaque personne.",
  ],
};
